import { call, put, select, takeEvery } from 'redux-saga/effects';
import { captureException } from '@sentry/nextjs';
import { selectMatchedStrategyCollection } from '../../../../Helpers/strategyCollection.helpers';
import { selectCurrentStepKey } from '../../../../Helpers/clientApiJourneyPosition.helpers';
import ActionTypes from '../../../../Data/ActionTypes';
import FetchStatus from '../../../../Data/FetchStatus';
import { incrementMetric } from '../../../../Services/Datadog';
import { getErrorTypeTag } from '../clientApiError.helpers';
import { getStepApi } from '../clientApiStep.helpers';
import { resolveDependencies } from '../clientApiDependencies.helpers';
import {
  setSolarVerifyStatus,
  setStepResponse,
} from '../../slices/clientApiJourney';
import { fetchClientApiVerifyPotential } from './fetchClientApiVerifyPotential';

export function* getClientApiVerifyPotentialWorker() {
  try {
    yield put(
      setSolarVerifyStatus({ solarVerifyStatus: FetchStatus.IN_PROGRESS })
    );

    const matchedCollection = yield select(selectMatchedStrategyCollection);
    const stepKey = yield select(selectCurrentStepKey);
    const api = getStepApi({
      collection: matchedCollection,
      stepKey,
      operation: 'verifyPotential',
    });

    if (!api?.url) {
      throw new Error(
        `No verifyPotential operation on strategy step ${stepKey}`
      );
    }

    const submissionId = yield select((state) => state.submission?.id);
    const token = yield select((state) => state.submission?.token);
    const stepStates = yield select(
      (state) => state.clientApiJourney.stepStates
    );
    const stepResponses = yield select(
      (state) => state.clientApiJourney.stepResponses
    );

    const body = resolveDependencies({
      dependencies: api.dependencies,
      ownKey: stepKey,
      ownInputs: {},
      stepStates,
      stepResponses,
    });

    const response = yield call(fetchClientApiVerifyPotential, {
      api,
      body,
      submissionId,
      token,
    });

    yield put(
      setStepResponse({ stepKey, operation: 'verifyPotential', response })
    );
    yield put(
      setSolarVerifyStatus({ solarVerifyStatus: FetchStatus.COMPLETED })
    );
  } catch (error) {
    incrementMetric({
      name: 'getClientApiVerifyPotentialError',
      tags: { type: getErrorTypeTag(error) },
    });
    captureException(error);
    yield put(setSolarVerifyStatus({ solarVerifyStatus: FetchStatus.FAILED }));
  }
}

export default function* getClientApiVerifyPotentialSaga() {
  yield takeEvery(
    ActionTypes.GET_CLIENT_API_VERIFY_POTENTIAL,
    getClientApiVerifyPotentialWorker
  );
}
